import React from "react";
import classNames from "classnames";

interface PageProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  /**
   * If true, uses h-[100dvh] for a fixed view.
   * If false (default), uses min-h-screen for scrollable pages.
   */
  fullHeight?: boolean;
}

export const Page = ({ children, className, id, fullHeight = false }: PageProps) => {
  return (
    <div
      id={id}
      className={classNames(
        "relative flex flex-col w-full",
        {
          "h-[100dvh] overflow-hidden": fullHeight,
          "min-h-screen": !fullHeight,
        },
        className
      )}
    >
      {children}
    </div>
  );
};
